import script from "./ReceivingSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivingSelector.vue?vue&type=script&setup=true&lang=js"

import "./ReceivingSelector.vue?vue&type=style&index=0&id=63502a63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63502a63"]])

export default __exports__